import { motion } from 'framer-motion';

const AnnouncementBar = () => {
  const announcements = [
    "New Deals Every Day",
    "100% Halal Certified | Dine-in & Takeaway Available",
    "44 Station Road, Solihull B91 3RX",
    "Call Us: 0121 725 4162",
  ];

  const tickerContent = [...announcements, ...announcements];

  return (
    <div
      className="bg-[#1A2E1F] text-[#C9A84C] h-9 flex items-center overflow-hidden"
      data-testid="announcement-bar"
    >
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: [0, -50 + '%'] }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: 25,
            ease: "linear",
          },
        }}
      >
        {tickerContent.map((text, index) => (
          <span
            key={index}
            className="mx-8 text-sm font-medium flex items-center gap-2"
          >
            {text}
          </span>
        ))}
      </motion.div>
    </div>
  );
};

export default AnnouncementBar;
